import { Store } from './store';

const API_KEY =
  window.location.origin.indexOf('windsorstore.com') > -1
    ? 'AIzaSyAeTZw-ttseoKrNwCEQOjqLEQkX_JFmeuY'
    : 'AIzaSyCQt8mUN8zA2y1ps1UzIPq9Pwg8c9qnkY4';

export class FindStore {
  #googleApiKey = API_KEY;

  constructor(node) {
    this.node = node;
    this.form = this.node.querySelector('form');
    this.input = this.node.querySelector('input[name="zip"]');
    this.select = this.node.querySelector('select[name="radius"]');
    this.address = window.localStorage.getItem('userAddress') || '';
    this.radius = window.localStorage.getItem('userRadius') || '25';
    this.getGeoBtn = this.node.querySelector('.pdp-c-find-store__current-location-btn');
    this.loadMoreLocationsBtn = null;
    // Variable to gather all Stores instances
    this.stores = [];
  }

  init() {
    // set initial values
    this.input.value = this.address;
    this.select.value = this.radius;

    // Bind events
    this.form.addEventListener('submit', this.#handleSubmit.bind(this));
    this.input.addEventListener('input', this.#handleInput.bind(this));
    this.select.addEventListener('change', this.#handleSelectChange.bind(this));
    this.getGeoBtn.addEventListener('click', this.#handleGetGeo.bind(this));
  }

  close() {
    // Remove any bind event
    this.form.removeEventListener('submit', this.#handleSubmit.bind(this));
    this.input.removeEventListener('input', this.#handleInput.bind(this));
    this.select.removeEventListener('change', this.#handleSelectChange.bind(this));
    this.getGeoBtn.removeEventListener('click', this.#handleGetGeo.bind(this));
    this.loadMoreLocationsBtn?.removeEventListener('click', this.#handleLoadMoreClick.bind(this));
  }

  #handleInput(event) {
    const value = event.target.value;
    window.localStorage.setItem('userAddress', value);
    this.address = value;
  }

  #handleSelectChange(event) {
    const value = event.target.value;
    window.localStorage.setItem('userRadius', value);
    this.radius = value;
  }

  /**
   * Triggers the localization of you machine according to built-in geolocalization
   * @returns - void -
   */
  #handleGetGeo() {
    // Guard condition: It will prevent trigger more than once the request
    if (this.form.ariaLabel === 'loading') return;

    if (!navigator.geolocation) {
      console.error('Geolocation not supported');
      const errorMessage = 'Geolocation is not supported in this device. Please, change device.';
      this.node.querySelector('.pdp-c-find-store__location-results').innerHTML = `
       <p class="pdp-c-find-store__location-no-stores">${errorMessage}</p>`;
      return;
    }

    navigator.geolocation.getCurrentPosition(this.#exposeGeoLocation.bind(this), this.#errorLocation.bind(this));
  }

  /**
   * Form handler that will gracefully trigger the retrieval of stores near you
   * @param {Event} event - form event
   * @returns - void -
   */
  #handleSubmit(event) {
    event.preventDefault();
    // Guard condition: It will prevent trigger more than once the request
    if (this.form.ariaLabel === 'loading') return;

    this.#findStore();
  }

  /**
   * Brings successfully your position in the world to continue fetching stores near by you
   * @param {Object} position - coordinates latitude and longitude of your machine in the world
   */
  #exposeGeoLocation(position) {
    window.localStorage.setItem(
      'userLatLong',
      JSON.stringify({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      }),
    );

    // Show built-in spinner while requesting data
    this.#setLoading('loading');

    this.#fetchStores(position.coords.latitude, position.coords.longitude);
  }

  /**
   * Handler your geolocalization error and show your error on the screen
   * @param {Object} err - information about your error
   */
  #errorLocation(err) {
    console.error('Error getting location', err);
    // User denied geolocation
    let errorMessage = '';
    if (err.code === 1) {
      // PERMISSION_DENIED
      errorMessage = 'User blocked geolocation on your browser. Please, turn on it.';
    } else if (err.code == 2) {
      // POSITION_UNAVAILABLE
      errorMessage = 'Position is unavailable in this device. Please, use another device.';
    } else {
      // err.code will be 3 - TIMEOUT
      errorMessage = 'We reached time allowed to acquire your geolocation. Please, try it again.';
    }
    this.node.querySelector('.pdp-c-find-store__location-results').innerHTML = `
      <p class="pdp-c-find-store__location-no-stores">${errorMessage}</p>`;
  }

  #clearLocalStorage() {
    window.localStorage.removeItem('userLatLong');
    window.localStorage.removeItem('userAddress');
    window.localStorage.removeItem('userRadius');
  }

  #setLoading(state = '') {
    this.form.ariaLabel = state;
  }

  /**
   * Get latitude and longitude according to zip code, city, or state and radius assigned by user and return specific stores
   */
  #findStore() {
    // Implement store finding logic here
    const encodedAddress = encodeURI(this.address);
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${this.#googleApiKey}`;

    // Show built-in spinner while requesting data
    this.#setLoading('loading');

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        const location = data.results[0].geometry.location;
        window.localStorage.setItem(
          'userLatLong',
          JSON.stringify({
            latitude: location.lat,
            longitude: location.lng,
          }),
        );
        this.#fetchStores(location.lat, location.lng);
      })
      .catch((error) => {
        console.error('Error while fetching address:', error);
        this.#clearLocalStorage();
        this.#setLoading(); // Clean loading state
      });
  }

  /** Get stores near you given latitude and longitude values */
  #fetchStores(latitude, longitude) {
    const skuAttribute = document
      .querySelector('[data-sku].pdp-c-atc-size-selector__size-item--active')
      .getAttribute('data-sku');
    const url = `https://inventory-lookup-service.wndsr.io/store_inventory_lookup?lat=${latitude}&lng=${longitude}&sku=${skuAttribute}&range=${this.radius}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.node.querySelector('.pdp-c-find-store__location-results').innerHTML = '';

        if (data.length === 0) {
          this.node.querySelector('.pdp-c-find-store__location-results').innerHTML = `
          <p class="pdp-c-find-store__location-no-stores">
            Oh no! This style isn't available in any nearby stores. Try expanding your distance for better results.
          </p>`;
          this.#setLoading(); // Clean loading state
          return;
        }

        this.#setLoading(); // Clean loading state because the request was successful

        const resultsPreheading = document.createElement('p');
        resultsPreheading.classList.add('pdp-c-find-store__location-results-preheading');
        resultsPreheading.textContent =
          "*We're unable to put store items on hold. Availability in store isn't guaranteed.";
        this.node.querySelector('.pdp-c-find-store__location-results').appendChild(resultsPreheading);

        // Set amount of locations or stores with this item
        const resultsHeading = document.createElement('h3');
        resultsHeading.classList.add('pdp-c-find-store__location-results-heading');
        // accum is accumulator and curr is the current store data item
        const numberOfStoresWithItem = data.reduce((accum, curr) => (curr.quantity !== 0 && accum + 1) || accum + 0, 0);
        resultsHeading.textContent = `${numberOfStoresWithItem} Locations with this item`;
        this.node.querySelector('.pdp-c-find-store__location-results').appendChild(resultsHeading);

        // Previously, it re-orders stores by units with quantity and distance by order descending
        const availableStores = data.filter((store) => store.quantity > 0).sort((a, b) => a.distance - b.distance);
        const unavailableStores = data.filter((store) => store.quantity === 0).sort((a, b) => a.distance - b.distance);
        const sortedStores = [...availableStores, ...unavailableStores];

        sortedStores.forEach((storeData, index) => {
          const isHiddenLocation = (window.innerHeight < 680 && index > 1) || index > 2;

          const store = new Store({ data: storeData, isHidden: isHiddenLocation, index });
          this.node.querySelector('.pdp-c-find-store__location-results').appendChild(store.render());
          this.stores.push(store); // pick Store instance up
        });

        // Launch this action in each Store instance
        // this for looping-condition is safe because this.stores never is null or undefined
        for (let i = 0; i < 3 && i < this.stores.length; i++) {
          const storeInstance = this.stores[i];
          storeInstance.handleStoreImpression();
        }

        if (data.length <= 3) return;

        this.loadMoreLocationsBtn = document.createElement('button');
        this.loadMoreLocationsBtn.classList.add('pdp-c-find-store__location-results-more-btn');
        this.loadMoreLocationsBtn.textContent = 'Load More Locations';
        this.node.querySelector('.pdp-c-find-store__location-results').appendChild(this.loadMoreLocationsBtn);

        // Defer this block because they are no user-visible tasks
        setTimeout(() => {
          this.loadMoreLocationsBtn.addEventListener('click', this.#handleLoadMoreClick.bind(this));
        }, 0);
      })
      .catch((error) => {
        console.error('Error while fetching store data:', error);
        this.#clearLocalStorage();
        this.#setLoading(); // Clean loading state
      });
  }

  /**
   * Handler that will render more locations on Find Store modal
   */
  #handleLoadMoreClick() {
    // Implement load more locations logic here
    this.loadMoreLocationsBtn.style.display = 'none';
    const hiddenStores = this.node.querySelectorAll(
      '.pdp-c-find-store__location-item.pdp-c-find-store__location-item--hidden',
    );
    hiddenStores.forEach((el) => {
      el.classList.remove('pdp-c-find-store__location-item--hidden');
      el.style.display = 'flex';
    });

    // Defer this block because they are no user-visible tasks
    setTimeout(() => {
      hiddenStores.forEach((el) => this.stores[Number(el.dataset.index)].handleStoreImpression());
    }, 0);
  }
}
